import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import Spinner from "reactjs-simple-spinner";


const Settings = (props) => {

    const [manage, setManage] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));

        direct_perm.map((perm, i) => {
            if (perm.name === 'manage beef price') {
                setManage(true)
                setLoading(false)
            }
        })

        setLoading(false)
    }, []);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (
        <>
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Loading App Settings..."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!loading && (
            <div
                id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <div className="container">
                            <div className="main-body">

                                <nav aria-label="breadcrumb" className="main-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={'/dashboard'}>Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">Settings</li>
                                    </ol>
                                </nav>


                                    <div className="row gutters-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row p-2">
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/age-limits'}
                                                               className="btn text-white btn-block btn-primary p-3">
                                                                <i className="fa fa-user-circle"></i>&nbsp;Age Limit
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/payment-methods'}
                                                               className="btn text-white btn-block btn-primary p-3">
                                                                <i className="fa fa-credit-card-alt"></i>&nbsp; Payment
                                                                Methods Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/sms-gateway'}
                                                               className="btn text-white btn-block btn-primary p-3">
                                                                <i className="fas fa-sms"></i>&nbsp;SMS Gateway
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/mail-server'}
                                                               className="btn text-white btn-block btn-primary p-3">
                                                                <i className="fa fa-envelope"></i>&nbsp; Emails
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/roles'}
                                                               className="btn text-white btn-block btn-primary p-3">
                                                                <i className="fa fa-cogs"></i>&nbsp;IAM Roles Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/commissions-settings'}
                                                               className="btn text-white btn-block btn-primary p-3">
                                                                <i className="fa fa-percent"></i>&nbsp;Commissions Rate
                                                                Management</a>
                                                        </div>
                                                        {manage && (
                                                            <div className="col-md-6 p-2 mt-3 mb-">
                                                                <a href={'/beef-price-management'}
                                                                   className="btn text-white btn-block btn-primary p-3">
                                                                    <i className="fa fa-money-check-dollar"></i>&nbsp;Beef
                                                                    Price
                                                                    Management</a>
                                                            </div>
                                                        )}

                                                    </div>
                                                    <hr/>
                                                    <hr/>
                                                    <div className="row p-2">
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/teams'}
                                                               className="btn btn-block btn-outline-primary p-3">
                                                                <i className="fa-solid fa-people-group"></i>&nbsp;Teams
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/channels'}
                                                               className="btn btn-block btn-outline-primary p-3">
                                                                <i className="fa-sharp fa-solid fa-signs-post"></i>&nbsp; Channels
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/positions'}
                                                               className="btn btn-block btn-outline-primary p-3">
                                                                <i className="fa-solid fa-address-card"></i>&nbsp; Positions
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/industries'}
                                                               className="btn btn-block btn-outline-primary p-3">
                                                                <i className="fa-solid fa-industry"></i>&nbsp; Industries
                                                                Management</a>
                                                        </div>
                                                        <div className="col-md-6 p-2 mt-3 mb-">
                                                            <a href={'/form-settings'}
                                                               className="btn btn-block btn-outline-primary p-3">
                                                                <i className="fa-solid fa-sticky-note"></i>&nbsp; Form
                                                                Settings
                                                            </a>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </>
    )

}

export default Settings;
